export function Header(){

  return <header className="p-2">
    <img src="/logo_musée.webp" alt="logo MO5" className="w-full"/>
  </header>
}